import '../App.css';
import TechIcon from './TechIcon';
import ProjectButton from './ProjectButton';
import {AiFillGithub} from "react-icons/ai";
import {FiExternalLink} from "react-icons/fi";

function ProjectCards({ data }) {

    return (
        <div className="ProjectCards">
            <div className='Project-Cards-Left'>
                <img src={data.cover} />
            </div>
            <div className='Project-Cards-Right'>
                <div>
                    <h4>{data.title}</h4>
                </div>
                <div className='Project-Description'>
                    <p>{data.description}</p>
                </div>
                <div className='Tech-Icons'>

                    {data.tech.map(techStack => <TechIcon key={data.id+2} data={techStack} />)}
                    
                </div>
                <div className='Project-Buttons'>
                    { data.github === "not available" ? '' : <ProjectButton name={"Github"} icon={<AiFillGithub/>} link={data.github} /> }
            
                    <ProjectButton name={"Live"} icon={<FiExternalLink/>} link={data.demo} />
                </div>

            </div>



        </div>
    )
}

export default ProjectCards;